import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=6560a577&scoped=true&shadow"
import script from "./Carousel.vue?vue&type=script&lang=js&shadow"
export * from "./Carousel.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Carousel.vue?vue&type=style&index=0&id=6560a577&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6560a577",
  null
  ,true
)

export default component.exports